import apiClient from "./apiClient";
import { MailDeliveryHealthResponse } from "../types/mail-delivery-health.types";

/**
 * Fetch mail delivery health aggregate for grants alert notification queue (F2).
 * Endpoint: GET /admin/mail/delivery-health (JWT + ADMIN role required server-side)
 */
export const getMailDeliveryHealth = async (): Promise<MailDeliveryHealthResponse> => {
  const { data } = await apiClient.get<MailDeliveryHealthResponse>(
    "/admin/mail/delivery-health"
  );
  return data;
};
